import { render } from "./DashboardTableWrapper.vue?vue&type=template&id=fc2678b0"
import script from "./DashboardTableWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardTableWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__